// extracted by mini-css-extract-plugin
export default {"collabsCard":"Vcomp_collabsCard__BSyW3","mobileBody":"Vcomp_mobileBody__ClgTR","projectsRow":"Vcomp_projectsRow__LF5zp"};